import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, Link, NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import logo from '../../assets/images/LogoWhite.png'
import '../../index.css'
import Modal from '../Modal'
import LanguageSelect from './NotLoggedInToolBar/LanguageSelect'
import MobileComplianceMobile from 'components/mobileComplianceModal/MobileComplianceModal'

const LandingNavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })
  const navigate = useNavigate()

  // ✅ Dynamically update `isMobile` when screen resizes
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Refs for the sidebar and toggle button
  const mobileMenuRef = useRef(null)
  const toggleButtonRef = useRef(null)

  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
    setIsMobileMenuOpen(false)
  }

  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  const handleHomeClick = () => {
    navigate('/')
    setIsMobileMenuOpen(false)
  }

  const handleAboutUsClick = () => {
    navigate('/about-us')
    setIsMobileMenuOpen(false)
  }

  const handleCategoriesClick = () => {
    navigate('/categories')
    setIsMobileMenuOpen(false)
  }

  const categoriesVariants = {
    animate: {
      scale: [1, 0.8, 1],
      transition: { duration: 1, repeat: Infinity, repeatDelay: 1 },
    },
  }

  // Close the sidebar if clicking outside (except the toggle button) or scrolling
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false)
      }
    }

    const handleScroll = () => {
      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    window.addEventListener('scroll', handleScroll)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isMobileMenuOpen])

  const [sideBarHeight, setSideBarHeight] = useState(null)

  useEffect(() => {
    const navbar = document.querySelector('.navbar')
    if (navbar) {
      setSideBarHeight(navbar.clientHeight)
    } else {
      setSideBarHeight(0)
    }
  }, [])

  return (
    <>
      <nav className="navbar h-20 z-50 px-2">
        <div className="navbar-container flex items-center justify-between w-full max-w-7xl mx-auto">
          {/* Responsive Logo */}
          <Link to="/" className="lg:h-12 h-8 max-w-56 w-20 lg:w-full">
            <img
              src={'logo.png'}
              className="h-full w-full xl:object-cover aspect-[179/49]"
              alt="Logo"
            />
          </Link>

          {/* Mobile Toggle Button */}
          <div className="flex   items-center px-2 ">
            <div className="mr-8 md:hidden block">
              <LanguageSelect />
            </div>
            <button
              ref={toggleButtonRef}
              className="navbar-toggle md:hidden block"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? '✕' : '☰'}
            </button>

            {/* desktop Menu */}

            <div
              ref={mobileMenuRef}
              style={{
                marginTop: isMobile ? sideBarHeight : 0,
                // height: `${sideBarHeight}`,
              }}
              className={`navbar-links  px-2 md:px-4  gap-4  top-[0px] transition-all duration-300 ease-linear right-0 h-auto w-full items-center hidden md:flex flex-row  py-2  z-10 static translate-x-0 `}
            >
              {/* Categories Button with Framer Motion */}
              <NavLink
                className={'text-white md:text-xs lg:text-sm'}
                to={'/categories'}
                onClick={handleCategoriesClick}
                variants={categoriesVariants}
                animate="animate"
                // style={!isMobile ? {} : { marginLeft: '13px' }}
              >
                Categories
              </NavLink>
              <NavLink
                // style={!isMobile ? { marginLeft: '28px' } : { marginLeft: '13px' }}
                // className="font-semibold h-11 flex items-center justify-center rounded-lg text-sm px-2  text-white  w-full lg:w-auto
                // animated-link bg-[#6941c6] hover:bg-[#5b0cb6] transition-all duration-300"
                className={'text-white md:text-xs lg:text-sm'}
                to={'/about-us'}
                // onClick={handleAboutUsClick}
                variants={categoriesVariants}
                animate="animate"
              >
                About Us
              </NavLink>
              <NavLink
                to="/tutor/register"
                // style={!isMobile ? { marginLeft: '15px', marginRight: '15px' } : {}}
                className="font-semibold h-11 flex items-center justify-center rounded-lg bg-primary-75 text-sm px-2  text-white  w-full lg:w-auto md:text-xs lg:text-sm"
                rel="noreferrer"
              >
                Become a Tutor
              </NavLink>

              <NavLink
                to="/student/register"
                className="font-semibold h-11 flex items-center justify-center rounded-lg bg-primary-75 text-sm px-4  text-white  w-full lg:w-auto md:text-xs lg:text-sm"
                rel="noreferrer"
              >
                Become a Student
              </NavLink>
              <button
                // style={!isMobile ? { marginLeft: '15px', marginRight: '15px' } : {}}
                className="font-semibold h-11 flex items-center justify-center rounded-lg bg-primary-75 text-sm px-2  text-white  w-full lg:w-auto md:text-xs lg:text-sm"
                onClick={() => navigate('/Login')}
              >
                LogIn
              </button>
              <div className="mr-3 ">
                <LanguageSelect />
              </div>
            </div>

            {/* Sidebar Menu */}
            <div
              onClick={() => setIsMobileMenuOpen(false)}
              ref={mobileMenuRef}
              className={`fixed top-0 w-full z-[50000] bg-black/50 transition-opacity duration-300 ease-linear right-0 h-screen  items-center flex  flex-col  py-2   md:hidden ${isMobileMenuOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className={`lg:hidden px-2 navbar-links w-3/4 max-w-80 gap-4 fixed top-[0px] transition-all duration-300 ease-linear right-0  h-screen flex  flex-col z-10 items-center bg-gradient-to-b from-[#f78430] to-[#cc154b] `}
              >
                <button
                  ref={toggleButtonRef}
                  className=" block text-right px-4 self-end  text-3xl font-bold text-white"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                  {isMobileMenuOpen ? '✕' : '☰'}
                </button>
                {/* Home Button - Only Visible on Mobile */}
                <button
                  className="font-semibold p-1.5 rounded-lg bg-primary-75 text-sm px-2 w-full lg:w-auto  text-white home-button"
                  onClick={handleHomeClick}
                >
                  Home
                </button>
                {/* Categories Button with Framer Motion */}
                <NavLink
                  // className="font-semibold h-11 flex items-center justify-center rounded-lg text-sm px-2  text-white  w-full lg:w-auto
                  // animated-link  bg-[#6941c6] hover:bg-[#5b0cb6] transition-all duration-300"
                  className={'text-white'}
                  to={'/categories'}
                  onClick={handleCategoriesClick}
                  variants={categoriesVariants}
                  animate="animate"
                  // style={!isMobile ? {} : { marginLeft: '13px' }}
                >
                  Categories
                </NavLink>
                <NavLink
                  // style={!isMobile ? { marginLeft: '28px' } : { marginLeft: '13px' }}
                  // className="font-semibold h-11 flex items-center justify-center rounded-lg text-sm px-2  text-white  w-full lg:w-auto
                  // animated-link bg-[#6941c6] hover:bg-[#5b0cb6] transition-all duration-300"
                  className={'text-white'}
                  to={'/about-us'}
                  // onClick={handleAboutUsClick}
                  variants={categoriesVariants}
                  animate="animate"
                >
                  About Us
                </NavLink>
                <button
                  // to="/tutor/register"
                  // style={!isMobile ? { marginLeft: '15px', marginRight: '15px' } : {}}
                  className="font-semibold h-11 flex items-center justify-center rounded-lg bg-primary-75 text-sm px-2  text-white  w-full lg:w-auto"
                  rel="noreferrer"
                  onClick={() => handleModalOpen('Tutor')}
                >
                  Become a Tutor
                </button>

                <button
                  className="font-semibold h-11 flex items-center justify-center rounded-lg bg-primary-75 text-sm px-4  text-white  w-full lg:w-auto"
                  rel="noreferrer"
                  onClick={() => handleModalOpen('Student')}
                >
                  Become a Student
                </button>
                <button
                  // style={!isMobile ? { marginLeft: '15px', marginRight: '15px' } : {}}
                  className="font-semibold h-11 flex items-center justify-center rounded-lg bg-primary-75 text-sm px-2  text-white  w-full lg:w-auto"
                  onClick={() => navigate('/Login')}
                >
                  LogIn
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <MobileComplianceMobile onClose={handleModalClose} open={modalData.isOpen} />
    </>
  )
}
export default LandingNavBar
